// jacques-andre-editeur\JAEfrontend\src\slices\alauneApiSlice.js
import { ALAUNE_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const alauneApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAlaune: builder.query({
      query: () => ({
        url: ALAUNE_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Alaune'],
    }),

    updateAlaune: builder.mutation({
      query: (data) => ({
        url: `${ALAUNE_URL}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Alaune'],
    }),
  }),
});

export const {
  useGetAlauneQuery,
  useUpdateAlauneMutation,
} = alauneApiSlice;
